import * as SelectFacetTracker from "@omni/services/tracking/trackers/feature/selectFacet.tracker";

import { SearchComponentOfType } from "@/utils/search/types/searchComponent";

import { Facet } from "./@types/facet.types";
import { FacetType } from "./@types/facetType.types";
import { FacetComponent } from "./facet.component";
import { getComponentForFacetType } from "./facet.rules";

type DelegatingFacetProps = {
    component: SearchComponentOfType<"FACETS">;
    facet: Facet<FacetType>;
};

const DelegatingFacet = ({ component, facet }: DelegatingFacetProps) => {
    const Component = getComponentForFacetType(facet.type);

    const sendEvent = (facetName: string, facetValue: string) => {
        SelectFacetTracker.trackFacet(facetName, facetValue, facet.index);
    };

    return (
        <FacetComponent facetName={facet.name}>
            <Component
                component={component}
                facet={facet}
                sendEvent={sendEvent}
            />
        </FacetComponent>
    );
};

export { DelegatingFacet };
